import { scorCount } from 'i18n/scorLocale';

export const formatScorDaysLeft = (count?: number | null): string => scorCount('days', count);

export const formatScorIncludedReports = (count?: number | null): string => scorCount('includedReports', count);

export const formatScorOutcomeReports = (count?: number | null): string => scorCount('outcomeReports', count);

export const formatScorInvitations = (count?: number | null): string => scorCount('invitations', count);
